export const BILLING_INVOICES_VIEW_STATE_KEY = "billing/invoices";

/** Persisted Billing invoice grid UI preferences (localStorage via ViewStateCacheService). */
export interface BillingInvoicesViewCachedState {
  columnOrder?: string[];
}

export const CASE_REIMBURSEMENTS_GRID_VIEW_STATE_KEY = "store/cases/reimbursements-grid";

/** Persisted case detail reimbursements grid column order. */
export interface CaseReimbursementsGridViewCachedState {
  columnOrder?: string[];
}

export const STORES_VIEW_STATE_KEY = "store/stores";

/** Persisted Stores UI preferences (localStorage via ViewStateCacheService). */
export interface StoresViewCachedState {
  viewMode?: "cards" | "grid";
  groupedMode?: boolean;
  collapsedGroups?: {
    owner?: boolean;
    shared?: boolean;
    pending?: boolean;
  };
}

export const DASHBOARD_VIEW_STATE_KEY = "dashboard";

/** Persisted dashboard widget UI preferences. */
export interface DashboardViewCachedState {
  storeProviderReportColumnOrder?: string[];
}
